module.exports = __webpack_public_path__ + "img/pek_33_reset.477becc3.png";